"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const START_SLASH_REGEX = /^\//;
function ensureStartSlash(p) {
    return START_SLASH_REGEX.exec(p) ? p : `/${p}`;
}
exports.default = ensureStartSlash;
